import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Login from "./Login";
import Register from "./Register";
import RegisterDetails from "./RegisterDetails";
import ChoosePreference from "./ChoosePreference";
import HomeNotLoggedIn from "./HomeNotLoggedIn";
import CariVideo from "./CariVideo";
import CariArtikel from "./CariArtikel";
import VideoDetails from "./VideoDetails";
import ArticleDetails from "./ArticleDetails";
import ForumCategory from "./ForumCategory";
import Telekonsultasi from "./Telekonsultasi";
import FaskesStroke from "./FaskesStroke";
import DukunganEmosional from "./DukunganEmosional";
import DiscussionDetails from "./DiscussionDetails";
import OnlineCommunity from "./OnlineCommunity";
import OnlineCommunityDetails from "./OnlineCommunityDetails";
import Reminders from "./Reminders";
import EditReminder from "./EditReminder";
import AddReminder from "./AddReminder";
import HomeLoggedIn from "./HomeLoggedIn";
import Profile from "./Profile";
import Notifications from "./Notifications";
import AdminLogin from "./AdminLogin";
import AdminVideo from "./AdminVideo";
import AdminUploadVideo from "./AdminUploadVideo";
import AdminArticle from "./AdminArticle";
import AdminUploadArticle from "./AdminUploadArticle";
import AdminCommunity from "./AdminCommunity";
import AdminAddCommunity from "./AdminAddCommunity";
import AdminFaskes from "./AdminFaskes";
import AdminAddFaskes from "./AdminAddFaskes";
import AdminAddDokter from "./AdminAddDokter";
import AdminUser from "./AdminUser";
import AdminAddUser from "./AdminAddUser";
import EditProfile from "./EditProfile";
import ForumTopic from "./ForumTopic";
import AdminEditUser from "./AdminEditUser";
import AdminUpdateCommunity from "./AdminUpdateCommunity";
import AdminUpdateArticle from "./AdminUpdateArticle";
import AdminUpdateVideo from "./AdminUpdateVideo";
import SuperAdmin from "./superAdmin/SuperAdmin";
import NotFound from "./404Page";
import AdminEditDokter from "./AdminEditDokter";
import AdminEditFaskes from "./AdminEditFaskes";
import ForgotPassword from "./ForgotPassword";
import AdminUserDashboard from "./AdminUserDashboard";
import AdminEditUserDashboard from "./AdminEditUserDashboard";
import ResetPassword from "./ResetPassword";
// import AdminForum from "./AdminForum";
import { SearchProvider } from "./contexts/SearchContext";
import AdminCategory from "./AdminCategory";
import AdminCaregiverPatient from "./AdminCaregiverPatient";


function App() {
  return (
    <SearchProvider>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/register/details" element={<RegisterDetails />} />
            <Route path="/preferences" element={<ChoosePreference />} />
            <Route path="/" element={<HomeNotLoggedIn />} />
            <Route path="/homelogin" element={<HomeLoggedIn />} />
            <Route path="/videos" element={<CariVideo />} />
            <Route path="/articles" element={<CariArtikel />} />
            <Route path="/video/:id" element={<VideoDetails />} />
            <Route path="/article/:id" element={<ArticleDetails />} />
            <Route path="/forum" element={<ForumCategory />} />
            <Route path="/telekonsultasi" element={<Telekonsultasi />} />
            <Route path="/faskes" element={<FaskesStroke />} />
            <Route
              path="/forum/dukungan-emosional"
              element={<DukunganEmosional />}
            />
            <Route path="/forum/:topicId" element={<ForumTopic />} />
            <Route
              path="/forum/:topicId/discussion/:id"
              element={<DiscussionDetails />}
            />
            <Route path="/online-community" element={<OnlineCommunity />} />
            <Route
              path="/online-community-details/:id"
              element={<OnlineCommunityDetails />}
            />
            <Route path="/reminders" element={<Reminders />} />
            <Route path="/add-reminder" element={<AddReminder />} />
            <Route path="/reminders/edit/:id" element={<EditReminder />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/notif" element={<Notifications />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/video" element={<AdminVideo />} />
            <Route path="/admin/video/upload" element={<AdminUploadVideo />} />
            <Route path="/admin/article" element={<AdminArticle />} />
            <Route
              path="/admin/article/upload"
              element={<AdminUploadArticle />}
            />
            <Route path="/admin/community" element={<AdminCommunity />} />
            <Route
              path="/admin/community/add"
              element={<AdminAddCommunity />}
            />
            <Route path="/admin/faskes" element={<AdminFaskes />} />
            <Route path="/admin/faskes/add" element={<AdminAddFaskes />} />
            <Route
              path="/admin/faskes/add-doctor"
              element={<AdminAddDokter />}
            />
            <Route path="/admin/adminlist" element={<AdminUser />} />
            <Route path="/admin/adminlist/add" element={<AdminAddUser />} />
            <Route path="/admin/userlist" element={<AdminUserDashboard />} />
            <Route path="/admin/category" element={<AdminCategory />} />

            <Route
              path="/admin/users/:id/edit"
              element={<AdminEditUserDashboard />}
            />

            <Route path="/edit-profile" element={<EditProfile />} />
            <Route
              path="/admin/faskes/edit-doctor/:id"
              element={<AdminEditDokter />}
            />
            <Route
              path="/admin/faskes/edit/:place_id"
              element={<AdminEditFaskes />}
            />
            <Route path="/admin/caregiver-patient" element={<AdminCaregiverPatient />} />
            {/* <Route path="/admin/forum" element={<AdminForum />} /> */}
            {/* <Route
            path="/admin/forum/add-category"
            element={<AdminAddForumCategory />}
            />
            <Route
            path="/admin/forum/edit-category/:id"
            element={<AdminEditForumCategory />}
            />
            <Route
            path="/admin/forum/category/:id/threads"
            element={<AdminForumThreads />}
            /> */}
            <Route
              path="/admin/adminlist/edit/:username"
              element={<AdminEditUser />}
            />
            <Route
              path="/admin/community/update/:id"
              element={<AdminUpdateCommunity />}
            />
            <Route
              path="/admin/article/edit/:id"
              element={<AdminUpdateArticle />}
            />
            <Route
              path="/admin/video/edit/:videoId"
              element={<AdminUpdateVideo />}
            />
            <Route path="/superadmin" element={<SuperAdmin />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
        <script
          defer
          src="https://cloud.umami.is/script.js"
          data-website-id="0c2faa60-e6ab-4455-94f5-d763883489aa"
        ></script>
      </AuthProvider>
    </SearchProvider>
  );
}

export default App;
